export default __webpack_public_path__ + "static/media/icon-sangho@3x.b1c24ccd.png";